import { css } from '@emotion/react';
import { formatPoints } from 'shared';

import { theme } from '../theme';

const styles = {
  wrapper: css`
    display: flex;
    gap: ${theme.spacing.sm};
    align-items: center;
    margin-right: ${theme.spacing.sm};
  `,
  initials: (tier?: string) => css`
    font: var(--font-p1-xs);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    border-radius: 50%;
    background-color: ${getTierBackgroundColor(tier)};
    text-transform: uppercase;
    height: 32px;
    width: 32px;
    margin: 0 ${theme.spacing.sm};
    color: ${getTierTextColor(tier)};
  `,
  points: css`
    font-weight: ${theme.fontWeight.black};
    text-transform: uppercase;

    @media (max-width: ${theme.breakpoints.tablet}) {
      display: none;
    }
  `,
};

export type ProfileLogoProps = {
  initials: string;
  tier?: string;
  points?: number | undefined;
  pos?: string;
};

export function ProfileLogo({ initials, tier, points, pos }: ProfileLogoProps) {
  const isPointsProvided = points !== undefined;

  return (
    <div>
      <div css={styles.wrapper}>
        {isPointsProvided && <span css={styles.points}>{pos ? formatPoints(points, pos) : `${points} P`}</span>}
        <span css={styles.initials(tier)}>{initials}</span>
      </div>
    </div>
  );
}

function getTierBackgroundColor(tier?: string) {
  const bg = theme.colors.background;
  if (!tier) {
    return bg.noMember;
  }
  switch (tier) {
    case 'D':
      return bg.ebDiamond;
    case 'G':
      return bg.ebGold;
    case 'P':
      return bg.ebPandion;
    case 'S':
      return bg.ebSilver;
    default:
      return bg.ebMember;
  }
}

function getTierTextColor(tier?: string) {
  return !tier || tier === 'D' ? theme.colors.text : theme.colors.white;
}

export function getUserProfileFromSessionStorage() {
  const dataStr: unknown = window?.sessionStorage?.getItem('prof-profile');

  if (typeof dataStr !== 'string') {
    return undefined;
  }

  try {
    const data = JSON.parse(dataStr);
    const individual = data?.individual;

    if (!individual) {
      return undefined;
    }

    return {
      initials: `${individual.firstName.charAt(0)}${individual.lastName.charAt(0)}`,
      tier: data.eurobonus?.currentTierCode,
      points: data.eurobonus?.totalPointsForUse ?? 0,
    };
  } catch (error) {
    console.log(error);
    return undefined;
  }
}
